export const getPageId = (documentId, pageId) => {
    return `${documentId}-page-${pageId}`;
};
